import { COLORS } from 'helpers/globals'

const button =  {
  background: COLORS.primary,
  color: 'white',
  fontWeight: '400',
  textAlign: 'center',
  padding: '.7rem 2.5rem',
  borderRadius: '1rem'
}

export default {
  floorPlanScaler: {
    flex: '0 0 auto',
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    zIndex: 2,
    paddingBottom: '1rem',
    background: 'white'
  },
  header: {
    padding: '1rem 2rem',
    minHeight: '5rem',
    fontSize: '1.8rem',
    fontWeight: '400',
    background: COLORS.primary,
    color: 'white'
  },
  info: {
    padding: '1rem 1rem 0 1rem'
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    padding: '1rem',
    justifyContent: 'center'
  },
  widthInput: {
    flex: 1,
    marginRight: '2rem',
    marginLeft: '1rem'
  },
  label: {
    fontWeight: 300,
    marginRight: '1rem'
  },
  radio: {
    marginRight: '.5rem',
    verticalAlign: '-.2rem'
  },
  button,
  cancelButton: {
    ...button,
    background: '#999999',
    marginLeft: '1rem',
    padding: '.7rem 2rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/BottomBar/FloorPlanScaler/style.js